import { render } from "./FlowerClock3.vue?vue&type=template&id=4e60865c&scoped=true"
import script from "./FlowerClock3.vue?vue&type=script&lang=js"
export * from "./FlowerClock3.vue?vue&type=script&lang=js"

import "./FlowerClock3.vue?vue&type=style&index=0&id=4e60865c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e60865c"]])

export default __exports__